export default "__VITE_ASSET__C$aCOG6R__"